import type { ComponentSchema } from '../../../../../schema-types'
import { CONTENT_PAGES, CONTENT_POINT_SCHEMA, headingFields, SECTION_STYLE_FIELDS } from './_fields'

/** Two to four short store promises on tint tiles. */
export const schema: ComponentSchema = {
  type: 'promises',
  label: 'Promises strip',
  description: 'Short store promises (delivery, payment, returns, support) with icons.',
  supportedPages: CONTENT_PAGES,
  variants: [{ id: 'v1', label: 'Tint tiles' }],
  commonFields: [
    ...headingFields(),
    {
      key: 'items',
      label: 'Promises',
      type: 'array',
      itemSchema: CONTENT_POINT_SCHEMA,
      default: [
        { icon: 'shipping', title: 'Fast delivery', body: 'Quick delivery across the city.' },
        { icon: 'secure', title: 'Pay on delivery', body: 'Pay in cash when your order arrives.' },
        { icon: 'refund', title: 'Easy returns', body: 'Not right? We will make it right.' },
        { icon: 'support', title: 'Here to help', body: 'Call or message us any day.' },
      ],
    },
    ...SECTION_STYLE_FIELDS,
  ],
}
